import { render, staticRenderFns } from "./AstaConsiglio.vue?vue&type=template&id=1d180278&scoped=true&"
import script from "./AstaConsiglio.vue?vue&type=script&lang=js&"
export * from "./AstaConsiglio.vue?vue&type=script&lang=js&"
import style0 from "./AstaConsiglio.vue?vue&type=style&index=0&id=1d180278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d180278",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d180278')) {
      api.createRecord('1d180278', component.options)
    } else {
      api.reload('1d180278', component.options)
    }
    module.hot.accept("./AstaConsiglio.vue?vue&type=template&id=1d180278&scoped=true&", function () {
      api.rerender('1d180278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaConsiglio.vue"
export default component.exports